class ScrollTrack extends HTMLElement {
    constructor() {
      super();
  
      this.maxScroll = 0;
      this.currentScroll = 0;
  
      this.btnPrev = this.querySelector("[data-prev]");
      this.btnNext = this.querySelector("[data-next]");
  
      this.slide = this.querySelector("[data-slide]");
      this.item = this.querySelector("[data-item]");
  
      this.init();
      this.setupMutationObserver();
    }
  
    init() {
      this.maxScroll =
        Number(this.slide.scrollWidth) - Number(this.slide.clientWidth);
  
      this.btnPrev.addEventListener("click", this.prevStep.bind(this));
      this.btnNext.addEventListener("click", this.nextStep.bind(this));
    }
  
    nextStep() {
      this.currentScroll += this.item.offsetWidth;
  
      if (this.maxScroll >= this.currentScroll) {
        this.slide.scrollTo(this.currentScroll, 0);
      } else {
        this.currentScroll = 0;
        this.slide.scrollTo(0, 0);
      }
    }
  
    prevStep() {
      this.currentScroll -= this.item.offsetWidth;
  
      if (this.currentScroll >= 0) {
        this.slide.scrollTo(this.currentScroll, 0);
      } else {
        this.currentScroll = this.maxScroll;
        this.slide.scrollTo(this.maxScroll, 0);
      }
    }
  
    recalculate() {
      this.maxScroll =
        Number(this.slide.scrollWidth) - Number(this.slide.clientWidth);
      this.currentScroll = 0;
      this.slide.scrollTo(0, 0);
      this.item = this.querySelector("[data-item]");
    }
  
    setupMutationObserver() {
      const observer = new MutationObserver(() => {
        this.recalculate();
      });
  
      const config = { childList: true };
  
      observer.observe(this.slide, config);
    }
}
  
customElements.define("scroll-track", ScrollTrack);

document.addEventListener('DOMContentLoaded', function () {
  input_quantity_normalize();
});


function clearCart() {
  fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      }
  })
  .then(response => {
      if (response.ok) {
          // O carrinho foi limpo com sucesso
          console.log('Carrinho limpo!');
          document.querySelector('.cart-remove-button').click();

      } else {
          // Algo deu errado
          console.error('Erro ao limpar o carrinho');
      }
  })
  .catch(error => console.error('Erro:', error));
}

function input_quantity_normalize(){
  try {
    // Seleciona todos os elementos com a classe .quantity__input
    const quantityInputs = document.querySelectorAll('.quantity__input');

    quantityInputs.forEach(function(input) {
      input.addEventListener('input', function() {
        try {
          
          const dataMax = parseInt(this.getAttribute('data-max'), 10); // Obtém o valor máximo do atributo 'max'

          // Força o atributo máximo do input
          this.setAttribute('max', dataMax);
          
          const max = parseInt(this.getAttribute('max'), 10); // Obtém o valor máximo do atributo 'max'
          const currentValue = parseInt(this.value, 10); // Valor atual inserido

          // Se o valor atual for maior que o máximo, define o valor para o máximo permitido
          if (currentValue > max) {
            this.value = max;
          }
        } catch (innerError) {
          console.error('Erro ao verificar o valor máximo:', innerError);
        }
      });
    });
  } catch (error) {
    console.error('Erro ao inicializar o script de validação de quantidade:', error);
  }
}

window.addEventListener('load', function() {
  try {
      const headerPrincipal = document.querySelector('.header-principal');
      
      if (!headerPrincipal) {
          throw new Error("Elemento .header-principal não encontrado.");
      }

      const observer = new MutationObserver((mutationsList) => {
          for (let mutation of mutationsList) {
              if (mutation.type === 'childList') {
                  const aphBarBar = document.querySelector('.aph_bar_bar');

                  if (aphBarBar) {
                      headerPrincipal.insertBefore(aphBarBar, headerPrincipal.firstChild);
                      observer.disconnect(); // Desconecta o observer após mover o elemento
                      break;
                  }
              }
          }
      });

      // Configura o observer para monitorar o body em busca de adições de elementos
      observer.observe(document.body, { childList: true, subtree: true });
  } catch (error) {
      console.error("Erro ao mover .aph_bar_bar:", error);
  }
});
